import React from 'react';
import { Chip as MuiChip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledChip = styled(MuiChip)(({ theme }) => ({

}));

export const Chip = (props) => {

    return <StyledChip {...props} />;
};
